module.exports = __webpack_public_path__ + "img/carpeta-outlined.9b94d4fa.svg";